import React from 'react';
import PlayContainer from 'containers/PlayContainer';

export default function PlayPage() {
    return (
        <PlayContainer />
    )
}
